import { Translations } from './translations';

export enum EditorActionEvents {
  MANAGE_BOOKINGS = 'manageBookings',
  OPEN_BOOK_BUTTON_SETTINGS = 'openBookButtonSettings',
  OPEN_DAILY_TIME_TABLE_SETTINGS = 'openDailyTimeTableSettings',
  OPEN_DAILY_TIME_TABLE_SETTINGS_TEXT_TAB = 'openDailyTimeTableSettingsTextTab',
  MANAGE_STATE = 'manageState',
  MANAGE_CLIENT_FLOW = 'manageClientFlow',
  OPEN_STAFF_LIST_SETTINGS = 'openStaffListSettings',
  OPEN_STAFF_LIST_TEXT_SETTINGS = 'openStaffListTextSettings',
  MANAGE_STAFF = 'manageStaff',
  OPEN_BOOKINGS_ADD_PANEL = 'openBookingsAddPanel',
  OPEN_BOOKINGS_PAGES_PANEL = 'openBookingsPagesPanel',
  CREATE_A_SERVICE = 'createAService',
  OPEN_MANAGE_AVAILABILITY = 'openManageAvailability',
  OPEN_BOOKINGS_SETTINGS = 'openBookingsSettings',
  OPEN_SHARABLE_LINKS = 'openSharableLinks',
  OPEN_INTEGRATIONS = 'openIntegrations',
  OPEN_CALENDAR = 'openCalendar',
}

export function generateActions(translation: Translations) {
  return {
    openAddPanel: {
      label: translation.t('bookings-descriptor.actions.open-add-panel'),
      actionId: EditorActionEvents.OPEN_BOOKINGS_ADD_PANEL,
    },
    createAService: {
      label: translation.t('bookings-descriptor.actions.create-a-service'),
      actionId: EditorActionEvents.CREATE_A_SERVICE,
    },
    openPagesPanel: {
      label: translation.t('bookings-descriptor.actions.open-pages-panel'),
      actionId: EditorActionEvents.OPEN_BOOKINGS_PAGES_PANEL,
    },
    manageBookingsAction: {
      label: translation.t('bookings-pages.actions.manage'),
      actionId: EditorActionEvents.MANAGE_BOOKINGS,
    },
    manageStateAction: {
      label: translation.t(
        'bookings.daily-timetable.component.label.SwitchState',
      ),
      actionId: EditorActionEvents.MANAGE_STATE,
    },
    bookButtonSettings: {
      label: translation.t('bookings.book-button.component.gfpp.Settings'),
      actionId: EditorActionEvents.OPEN_BOOK_BUTTON_SETTINGS,
    },
    openDailyTimeTableSettings: {
      label: translation.t('bookings.daily-timetable.component.gfpp.Settings'),
      actionId: EditorActionEvents.OPEN_DAILY_TIME_TABLE_SETTINGS,
    },
    openDailyTimeTableSettingsTextTab: {
      label: translation.t(
        'bookings.daily-timetable.component.gfpp.change-text',
      ),
      actionId: EditorActionEvents.OPEN_DAILY_TIME_TABLE_SETTINGS_TEXT_TAB,
    },
    manageStaffAction: {
      label: translation.t('bookings.staff-list.component.gfpp.manage-staff'),
      actionId: EditorActionEvents.MANAGE_STAFF,
    },
    manageClientFlowAction: {
      label: translation.t('bookings-descriptor.actions.manage-client-flow'),
      actionId: EditorActionEvents.MANAGE_CLIENT_FLOW,
    },
    openStaffListSettings: {
      label: translation.t('bookings.staff-list.component.gfpp.Settings'),
      actionId: EditorActionEvents.OPEN_STAFF_LIST_SETTINGS,
    },
    openStaffListTextSettings: {
      label: translation.t(
        'bookings.daily-timetable.component.gfpp.change-text',
      ),
      actionId: EditorActionEvents.OPEN_STAFF_LIST_TEXT_SETTINGS,
    },
    openManageAvailability: {
      label: translation.t('bookings-descriptor.actions.manage-availability'),
      actionId: EditorActionEvents.OPEN_MANAGE_AVAILABILITY,
    },
    openBookingsSettings: {
      label: translation.t('bookings-descriptor.actions.bookings-settings'),
      actionId: EditorActionEvents.OPEN_BOOKINGS_SETTINGS,
    },
    openSharableLinks: {
      label: translation.t('bookings-descriptor.actions.sharable-links'),
      actionId: EditorActionEvents.OPEN_SHARABLE_LINKS,
    },
    openIntegrations: {
      label: translation.t('bookings-descriptor.actions.integrations'),
      actionId: EditorActionEvents.OPEN_INTEGRATIONS,
    },
    openCalendar: {
      label: translation.t('bookings-descriptor.actions.calendar'),
      actionId: EditorActionEvents.OPEN_CALENDAR,
    },
  };
}
export type EditorActions = ReturnType<typeof generateActions>;
